import React, { useState, useEffect } from 'react';
import { mergeStyles, IconButton } from '@fluentui/react';

export const AutoResizeIcon = (props) => {
  const { containerRef, columnIndex, isIconShow } = props;
  const containerEl = containerRef ? containerRef.current : null;
  const style = {
    root: {
      zIndex: 4, width: 20, height: 20, transform: 'scale(0.8)', visibility: isIconShow ? 'visible' : 'hidden',
    },
    icon: {
      fontSize: 14, fontWeight: 'bold !important', color: '#323130',
    },
  };

  const onClickAutoResize = (ev) => {
    let autoResizeDivider;

    if (containerEl) {
      autoResizeDivider = containerEl.querySelector(`[data-sizer-index="${columnIndex}"]`);
    }

    if (autoResizeDivider) {
      ev.stopPropagation();
      const dblClickEvent = new MouseEvent('dblclick', { bubbles: true, cancelable: true });
      autoResizeDivider.dispatchEvent(dblClickEvent);
    }
  };

  return <IconButton styles={style} onClick={onClickAutoResize} iconProps={{ iconName: 'ChromeFullScreen' }} />;
};

export const WithAutoResizeIcon = (props) => {
  const {
    columnIndex, children, containerRef, columnHeaderRef,
  } = props;

  const columnHeader = columnHeaderRef ? columnHeaderRef.current : (containerRef.current && containerRef.current.querySelectorAll('[role="columnheader"]')[columnIndex]);
  const [isIconShow, setIsIconShow] = useState(false);

  const onMouseEnterHeader = () => {
    setIsIconShow(true);
  };

  const onMouseLeaveHeader = () => {
    setIsIconShow(false);
  };

  useEffect(() => {
    if (columnHeader) {
      columnHeader.addEventListener('mouseenter', onMouseEnterHeader);
      columnHeader.addEventListener('mouseleave', onMouseLeaveHeader);
    }

    return () => {
      if (columnHeader) {
        columnHeader.removeEventListener('mouseenter', onMouseEnterHeader);
        columnHeader.removeEventListener('mouseleave', onMouseLeaveHeader);
      }
    };
  }, [columnHeader]);

  return (
    <div className={mergeStyles({ display: 'inline-flex', alignItems: 'center' })}>
      {children}
      <AutoResizeIcon columnIndex={columnIndex} containerRef={containerRef} isIconShow={isIconShow} />
    </div>
  );
};
